// Shared, product-agnostic formatting for a product's signatura facets
// (route, dispensing unit, dispensed quantity). Used anywhere wm shows or
// builds a product or dose — pricing, intake, refills, and order
// lists/previews/details — so no screen has to hardcode an assumption that
// a product is an injection, dosed in mL, or dosed weekly.

const UNIT_ABBREVIATIONS = {
  milliliter: 'mL',
  milliliters: 'mL',
};

// "Tablet" + qty 1 -> "Tablet"; + qty 3 -> "Tablets". "Milliliter" is
// abbreviated to "mL" and never pluralized (a unit of measure, not a count
// of discrete items).
export const formatDispenseUnitLabel = (unit, quantity) => {
  const label = String(unit || '').trim();
  if (!label) return '';

  const abbreviation = UNIT_ABBREVIATIONS[label.toLowerCase()];
  if (abbreviation) return abbreviation;

  const qty = Number(quantity);
  const isSingular = Number.isFinite(qty) && Math.abs(qty) === 1;
  return isSingular || label.toLowerCase().endsWith('s') ? label : `${label}s`;
};

// The total dispensed quantity for `months` months of supply of `product`,
// e.g. { dispense_qty_per_month: 30, dispense_unit: 'Tablet' } for 3 months
// -> "90 Tablets". Returns null when the product doesn't carry these fields
// (e.g. the pre-migration window), so callers can fall back to today's text.
export const formatDispenseQuantity = (product, months) => {
  const perMonth = Number(product?.dispense_qty_per_month);
  const monthsNum = Number(months);
  if (!Number.isFinite(perMonth) || !Number.isFinite(monthsNum)) return null;

  const quantity = perMonth * monthsNum;
  const roundedQuantity = Number.isInteger(quantity) ? quantity : Math.round(quantity * 100) / 100;
  const unitLabel = formatDispenseUnitLabel(product?.dispense_unit, roundedQuantity);

  return unitLabel ? `${roundedQuantity} ${unitLabel}` : String(roundedQuantity);
};

export const findProductByCode = (products = [], code) => {
  if (code == null || !Array.isArray(products)) return null;
  return products.find(p => String(p?.product_code) === String(code)) || null;
};
